import { sidebar } from "../../helpers/refs"
import { ReactElement, ReactNode } from "react"
import { Navigate, useLocation } from "react-router-dom"
import Header from "../../components/header/Header"
import Sidebar from "../../components/sidebar/Sidebar"
import { authRedirectPath } from "../../constants/routes"
import useAuth from "../../hooks/useAuth"
import PageLoader from "../../components/PageLoader"

type Props = {
  children: ReactNode
}

export default function PrivateWrapper({ children }: Props): ReactElement {
  const { onFirstLoad, user } = useAuth()
  const location = useLocation()

  return (
    <>
      {onFirstLoad
        ? <PageLoader className="h-screen w-screen top-0 left-0 fixed"/>
        : user
          ?
          <div className="private">
            <Sidebar ref={sidebar} />

            <div className="private__content">
              <Header />

              <main className="private__main">
                {children}
              </main>
            </div>
          </div>
          : <Navigate to={authRedirectPath} state={{ from: location }} replace/>
      }
    </>
  )
}
